import React from "react";

export default function AdminTabs({ tabs, active, onChange }) {
  return (
    <div className="flex gap-2 mb-5">
      {tabs.map((t) => (
        <button
          key={t.key}
          onClick={() => onChange(t.key)}
          className={`text-xs uppercase tracking-widest px-4 py-2 rounded ${active === t.key ? "bg-br-black text-white" : "bg-white text-gray-700 border border-gray-200 hover:border-br-bronze"}`}
          data-testid={`admin-tab-${t.key}`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
